import { store } from "../stores/clientStore";

// Get Url Info from Environment Variables
const apiVersion = process.env.REACT_APP_API_VERSION;
const apiUrl = process.env.REACT_APP_API_URL;
export const domain = apiUrl + "/" + apiVersion;

export const tokenUrl = process.env.REACT_APP_TOKEN_URL + "/token";
export const systemDownMessage = process.env.REACT_APP_SYSTEM_DOWN_MESSAGE;
export const applicationEnum = process.env.REACT_APP_APPLICATION_ENUM;

// Get Other Information from the Redux Store
export const token = () => {
  return store.getState() ? store.getState().userIdentity.token : null;
};

export const selectedClient = () => {
  console.log("selectedClient", store.getState().userIdentity.selectedClient);
  return store.getState().userIdentity.selectedClient;
};

// Returns just the Id and not the entire JSON object
export const selectedClientId = () => {
  const selectedClientId = store.getState().userIdentity.selectedClient.value;
  console.log("selectedClientId", selectedClientId);
  return selectedClientId;
};

// Get Roles from saved state
export const roles = () => {
  return store.getState().userIdentity.identity.roles
    ? store.getState().userIdentity.identity.roles.toString()
    : "";
};

// Returns list of clients from state
export const clientList = () => {
  return store.getState().userIdentity
    ? store.getState().userIdentity.identity.clients
    : [];
};

export const identity = () => {
  return store.getState().userIdentity
    ? store.getState().userIdentity.identity
    : {};
};
